export default __webpack_public_path__ + "static/media/Vector (3).a6aa0994.svg";